import { taskApi } from "@/axios/company";
import PaginationSelector from "./PaginationSelector";

type Params = Omit<Parameters<typeof taskApi.listOptions>[0], 'pageIndex' | 'pageSize'>;

// 提取 records 数组元素的类型
type TaskRecord = Awaited<ReturnType<typeof taskApi.listOptions>>['records'][number];

/** 获取企业监控任务列表选择器（基于 PaginationSelector 的便捷封装） */
const MonitorTaskSelector = ({
  params,
  placeholder,
  ...props
}: {
  params: Params;
  value?: any;
  onChange?: (value: any, selectedData?: TaskRecord) => void;
  placeholder?: string;
}) => {
  return (
    <PaginationSelector<TaskRecord, Params>
      fetchApi={(searchParams) => taskApi.listOptions(searchParams)}
      params={params}
      fieldNames={{ label: 'taskName', value: 'taskId' }}
      placeholder={placeholder || '请输入任务名称'}
      value={props.value}
      onChange={props.onChange}
      searchParamKey="taskName"
    />
  );
};

export default MonitorTaskSelector;
